import { render, staticRenderFns } from "./StatEffect.vue?vue&type=template&id=8f2d8748&"
import script from "./StatEffect.vue?vue&type=script&lang=js&"
export * from "./StatEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports